var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_82_218)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8442 24.483C36.8442 32.1233 30.6615 38.327 23.0455 38.327C15.4294 38.327 9.24675 32.1233 9.24675 24.483V24.4765C9.24675 18.1632 13.4683 12.8304 19.2305 11.1689L18.5812 10.6819C18.0698 10.2988 17.7695 9.69731 17.7695 9.05851C17.7695 8.74033 17.8442 8.43108 17.9821 8.15348C11.0446 10.3182 6.00081 16.8117 6 24.4789V24.4805C6.00162 33.9155 13.6388 41.5738 23.0455 41.5738C32.4529 41.5738 40.0909 33.9139 40.0909 24.4789C40.0909 15.6259 33.5 8.34018 25.0747 7.47086V5.40593C25.0747 5.25253 24.9878 5.11129 24.8506 5.04311C24.7127 4.97411 24.5487 4.98873 24.4253 5.08127L19.5552 8.73384C19.4529 8.81014 19.3929 8.93108 19.3929 9.05851C19.3929 9.18595 19.4529 9.30688 19.5552 9.38318L24.4253 13.0358C24.5487 13.1283 24.7127 13.1429 24.8506 13.0739C24.9878 13.0057 25.0747 12.8645 25.0747 12.7111V10.7241C31.6964 11.496 36.8442 17.3694 36.8442 24.483ZM25.8864 25.3044L30.5089 28.8604C30.6315 28.9545 30.7971 28.9716 30.9359 28.9034C31.0747 28.8344 31.1623 28.6932 31.1623 28.5389V20.4221C31.1623 20.2679 31.0747 20.1266 30.9359 20.0576C30.7971 19.9895 30.6315 20.0065 30.5089 20.1007L25.8864 23.6567V21.2338C25.8864 20.5617 25.3409 20.0163 24.6688 20.0163H16.1461C15.474 20.0163 14.9286 20.5617 14.9286 21.2338V27.7273C14.9286 28.3993 15.474 28.9448 16.1461 28.9448H24.6688C25.3409 28.9448 25.8864 28.3993 25.8864 27.7273V25.3044Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_82_218",
    x: 0,
    y: 0,
    width: 46.0908,
    height: 48.5737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.184314 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_82_218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_82_218",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraClick);
export default __webpack_public_path__ + "static/media/camera-Click.280244ab452c2878f41552322234005d.svg";
export { ForwardRef as ReactComponent };